<template>
  <div id="app">
  <nav-bar/>
  <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
export default {
  name: 'App',
  components: {
    NavBar
  },
  created () {
    
  },
  mounted () {
    
  },
  data () {
    return {
      
    }
  },
  computed: {
    
  },
  watch: {
    
  },
}
</script>

<style lang="scss">

</style>
